"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaveAckMessage = void 0;
var MessageType_1 = require("./MessageType");
var LeaveAckMessage = (function () {
    function LeaveAckMessage(payload) {
        this.t = MessageType_1.MessageType.LEAVE_ACK;
        this.d = payload;
    }
    return LeaveAckMessage;
}());
exports.LeaveAckMessage = LeaveAckMessage;
//# sourceMappingURL=LeaveAckMessage.js.map